import React, { useEffect, useReducer } from "react";
import { useSelector } from "react-redux";
import { CustomButton, CustomTooltip, I18nTranslate, createNotification, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DocumentCenterMenuHeader.module.css";

export default function DocumentCenterMenuHeader({ onImportFile, onOpenNewFolderDialog }) {
	const hasReceivedModifications = useSelector(({ documentCenter }) => documentCenter.hasReceivedModifications);
	const hasActionPermission = useSelector(({ documentCenter }) => documentCenter.hasActionPermission);
	const [openNewFolderDialog, dispatchOpenNewFolderDialog] = useReducer((prev) => !prev, false);

	useEffect(() => {
		if (hasReceivedModifications && openNewFolderDialog) {
			dispatchOpenNewFolderDialog();
		}
	}, [hasReceivedModifications, openNewFolderDialog]);

	const handleOpenNewFolderDialog = () => {
		onOpenNewFolderDialog();
	};
	const handleClickImport = () => {
		document.getElementById("import")?.click();
	};
	const handleImportFile = (e) => {
		const allowedFiles = Object.values(e.target.files).filter((file) => typeof file !== "number");
		if (Object.values(e.target.files).length > allowedFiles.length) {
			createNotification({
				type: "error",
				message: translate("common:upload-file.bad-format"),
			});
		}
		if (allowedFiles.length > 0) {
			onImportFile(allowedFiles);
		}
	};
	return (
		hasActionPermission && (
			<>
				<CustomTooltip placement="top-end" title={translate("common:upload-file.size-condition")}>
					<CustomButton
						fullWidth
						className={styles.importBtn}
						color="primary"
						startIcon={icon.faDownload}
						variant="contained"
						onClick={handleClickImport}
					>
						<I18nTranslate autoTranslate="no" translationKey="document-center.main-drop-down.import" />
					</CustomButton>
				</CustomTooltip>
				<input
					hidden
					multiple
					accept="*"
					data-cy="documentCenterMainDropDown_import"
					id="import"
					name="import"
					type="file"
					onChange={handleImportFile}
				/>
				<CustomButton
					fullWidth
					className={styles.importBtn}
					color="primary"
					startIcon={icon.faPlus}
					variant="outlined"
					onClick={handleOpenNewFolderDialog}
				>
					{translate("document-center.main-drop-down.folder")}
				</CustomButton>
			</>
		)
	);
}
